import roleType from 'constants/roleType';

/**
 * Check if admin has some types of role
 * @param object admin
 * @param Array types
 * @returns Boolean
 */
export const checkAdminRolesType = (admin, types) => {
    const _types = Array.isArray(types) ? types : [types];
    return admin?.roles?.some(role => _types.includes(role.type));
};

/**
 * Check if admin is a ROOT Admin
 * @param object admin
 * @returns Boolean
 */
export const isRootAdmin = admin => {
    return checkAdminRolesType(admin, roleType.ROOT);
};

/**
 * Check if admin is a ROOT or SUPPORT Admin
 * @param object admin
 * @returns Boolean
 */
export const isRootOrSupportAdmin = admin => {
    return checkAdminRolesType(admin, [roleType.ROOT, roleType.SUPPORT]);
};
